// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__281pl","footer":"ModalInfo_footer__3dfQi"};